import { isUndefined } from 'lodash';
import Embed from './embed';

class TiktokEmbed extends Embed {
  static create(value) {
    const domNode = super.create({
      ...value,
      label: 'tiktok',
      iconName: '',
      iconClass: 'fa-tiktok',
      buttons: ['edit'],
      denseMedia: true,
    });

    domNode.insertAdjacentHTML('beforeend', this.html(value));

    return domNode;
  }

  static value(domNode) {
    const data = domNode.dataset;
    console.debug('value data set', data);
    return {
      url: data.embedUrl,
    };
  }

  static html({
    url,
  }) {
    const urlId = `${url}`.split('/')[5];
    const tiktokEmbed = `<iframe width="323" height="740" src="https://www.tiktok.com/embed/v2/${urlId}" frameborder="0"></iframe>`;
    return `
    <div class="ql-text-wrapper">
      ${tiktokEmbed}
    </div>
    `;
  }
}

TiktokEmbed.blotName = 'tiktokEmbed';
TiktokEmbed.className = 'ql-tiktok';
TiktokEmbed.tagName = 'div';

export default TiktokEmbed;
